export const GET_DEPRECIATION_LIST = '/depreciation/get_list';
export const SHOW_DATA = '/depreciation/show_data';
export const CREATE_DATA = '/depreciation/create_data';
export const UPDATE_DATA = '/depreciation/update_data';
export const REMOVE_DATA = '/depreciation/remove_data';
export const GET_ORDINANCE_REVISION_LIST = 'building_settings/get_ordinance_revision_list';

export const FORM_DATA = {
  depreciation_rate: '',
  from: '',
  to: '',
};